<mat-form-field appearance="outline" [floatLabel]="selectedTags.length>0 ? 'always' :'auto'" >
  <mat-label >{{filedName |translate}}</mat-label>
    <mat-chip-grid #chipGrid aria-label="Enter fruits">

      <ng-container *ngFor="let tag of selectedTags; let i=index">
        @if(i<2){
          <app-custom-chip-colored 
              class="p-1"
              [label]="tag.name" 
              [color]="tag.color ?? tagBgColor" 
              [labelColor]="'#303030'" 
              [closeColor]="tag.closeColor ?? tagCloseColor" 
              [prefixAvatar]="tag.photo" 
              [prefixAvatarWidth]="'1rem'" 
              [prefixAvatarHeight]="'1rem'"
              [showClose]="showTagClose"
              (handleClick)="remove(i)"
            > </app-custom-chip-colored>
        }@else {
          
        }  

        </ng-container>

      <input
          type="text"
          class="multiselect-input"
          aria-label="auto complete"
          matInput
          [disabled]="isDisabled"
          [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matAutocomplete]="autoList"
          (blur)="onblurInput()"
          (input)="typeHandle(autocompleteList.value)"
          [disabled]="isDisabled"
          #autocompleteList
      />
      @if(selectedTags.length>2){
        <span class="plus-count">+{{selectedTags.length-2}}</span>
      }
      <mat-autocomplete
            #autoList="matAutocomplete"
        >
            <!-- <mat-option *ngIf="autoCompleteList.length == 0"></mat-option> -->
            @if (hasSelectAll) {
              <div class="full-width-checkbox-option">
                <mat-option #allCheck *ngIf="autoCompleteList.length">
                  <app-custom-check-box
                          [id]="'All'"
                          [isChecked]="selectedTags.length==autoCompleteList.length"
                          (handleClick)="selectAll($event);"
                          [label]="'All'"
                      >
                  </app-custom-check-box>
                </mat-option>
              </div>
              <hr>
            }
            <mat-option *ngFor="let item of autoCompleteList" [value]="item">
              <div class="d-flex align-items-center">
                <div class="full-width-checkbox-option">
                  <app-custom-check-box [id]="item._id" [label]="item.name" [isChecked]="checkSelected(item)" (handleClick)="select($event,item)"></app-custom-check-box>
                </div>
              </div>
            </mat-option>
      </mat-autocomplete>
    </mat-chip-grid>
  </mat-form-field>